// 小程序全部分类页面
export default {
  routes: [
    {
      path: '/history',
      name: 'history',
      meta: {
        desc: '足迹',
        pageId: 'V4961'
      },
      component: () => import(/* webpackChunkName: "History" */ '../views/history/index.vue')
    },
    {
      path: '/style-recommend',
      name: 'style-recommend',
      meta: {
        desc: '同款推荐',
        pageId: 'J9719'
      },
      component: () =>
        import(/* webpackChunkName: "StyleRecommend" */ '../views/history/recommend.vue')
    },
    {
      path: '/prerender/history',
      name: 'pre-render-history',
      meta: {
        desc: '足迹'
      },
      component: async () => await import('../views/history/index-prerender.vue')
    }
  ]
}
